export default __webpack_public_path__ + "static/media/disable-process-two.bd1dd82b.svg";